import type { FocusEvent, FunctionComponent, HTMLProps, RefObject } from 'react'
import React from 'react'

import classnames from 'classnames'

import styles from './TooltipErrorMessage.module.scss'

export const TooltipErrorMessage: FunctionComponent<
  TooltipErrorMessageProps
> = ({
  contents,
  className,
  isTooltipOpen,
  tooltipRef,
  handleTooltipBlur,
  ...rest
}) => {
  return (
    <>
      {isTooltipOpen && (
        <div
          role="tooltip"
          data-testid="error-message-container"
          className={classnames(styles.errorMessageContainer, className)}
          ref={tooltipRef}
          onBlur={handleTooltipBlur}
          {...rest}
        >
          <div className={styles.errorMessage} data-testid="error-message">
            <p dangerouslySetInnerHTML={{ __html: contents }} />
          </div>
        </div>
      )}
    </>
  )
}

///////// IMPLEMENTATION /////////

export type TooltipErrorMessageProps = {
  /**
   *  Optional tooltip className.
   */
  className?: string
  /**
   * Contents of tooltip box.
   */
  contents: string
  /**
   *  Determines if the tooltip is open or closed.
   */
  isTooltipOpen: boolean
  /**
   *  Reference object for tooltip.
   */
  tooltipRef: RefObject<HTMLDivElement>
  /**
   *  Close event handler for tooltip.
   */
  handleTooltipBlur: (e: FocusEvent) => unknown
} & HTMLProps<HTMLDivElement>
